export const budgetEditWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const budgetEditRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};
